import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Search } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 glass-nav border-b border-primary/10" data-testid="site-header">
      <div className="container-page flex h-[76px] items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link" aria-label="Black Health Resources home">
          <img src="/brand/cbhc-symbol.png" alt="CBHC" className="h-9 w-9 shrink-0 rounded" loading="eager" decoding="async" />
          <span className="font-display text-xl font-bold leading-tight text-primary md:text-2xl tracking-tight">
            Black Health Resources
          </span>
        </Link>

        <nav className="hidden items-center gap-7 md:flex">
          <NavLink
            to="/directory"
            data-testid="nav-directory"
            className={({ isActive }) =>
              `text-sm font-semibold transition-colors ${isActive ? "text-primary" : "text-foreground/80 hover:text-primary"}`
            }
          >
            Directory
          </NavLink>
          <NavLink
            to="/#categories"
            data-testid="nav-categories"
            className="text-sm font-semibold text-foreground/80 transition-colors hover:text-primary"
          >
            Categories
          </NavLink>
          <NavLink
            to="/about"
            data-testid="nav-about"
            className={({ isActive }) =>
              `text-sm font-semibold transition-colors ${isActive ? "text-primary" : "text-foreground/80 hover:text-primary"}`
            }
          >
            About
          </NavLink>
          <NavLink
            to="/blog"
            data-testid="nav-blog"
            className={({ isActive }) =>
              `text-sm font-semibold transition-colors ${isActive ? "text-primary" : "text-foreground/80 hover:text-primary"}`
            }
          >
            Blog
          </NavLink>
          <a
            href="https://coloradoblackhealth.org/"
            target="_blank"
            rel="noreferrer"
            className="text-sm font-semibold text-foreground/80 transition-colors hover:text-primary"
            data-testid="nav-cbhc"
          >
            CBHC
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/directory")}
            className="grid h-10 w-10 place-items-center rounded-full border border-border bg-white/60 text-primary transition-colors hover:bg-white md:hidden"
            data-testid="header-search-mobile"
            aria-label="Search"
          >
            <Search className="h-4 w-4" />
          </button>
          {user ? (
            <div className="flex items-center gap-2">
              {(user.role === "admin" || user.role === "manager") && (
                <Link to="/admin" className="hidden text-sm font-semibold text-primary hover:text-accent md:inline" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <Link to="/dashboard" className="hidden text-sm font-semibold text-foreground/80 transition-colors hover:text-primary md:inline" data-testid="nav-dashboard">
                Dashboard
              </Link>
              <span className="hidden text-sm text-muted-foreground md:inline" data-testid="header-user-name">
                {user.name}
              </span>
              <button onClick={logout} className="btn-secondary !py-2 !px-3 text-sm" data-testid="logout-btn">
                <LogOut className="h-4 w-4" /> Logout
              </button>
            </div>
          ) : (
            <>
              <Link to="/login" className="hidden text-sm font-semibold text-foreground/80 transition-colors hover:text-primary md:inline" data-testid="nav-login">
                Sign in
              </Link>
              <Link to="/signup" className="btn-primary !py-2 !px-4 text-sm" data-testid="nav-signup">
                Get listed
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
